import React from "react";
import { useLocation, useNavigate } from "react-router";
import styled from "styled-components/macro";
import { colors } from "theme/Theme";
import { OtherCategory } from "../types";

interface CategoryRowProps {
  category: OtherCategory;
}

const CategoryRow: React.FC<CategoryRowProps> = ({ category }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isIncludedInPathName = location.pathname.includes(category.route);

  const handleClick = () => {
    if (!isIncludedInPathName) {
      navigate(category.route);
    }
  };

  return (
    <CategoryRowContainer
      className={isIncludedInPathName ? "active" : ""}
      onClick={handleClick}
    >
      <span className={`text-sm`}>{category.title}</span>
    </CategoryRowContainer>
  );
};

const CategoryRowContainer = styled.div`
  border: 1px solid ${colors.gray};
  padding: 10px;

  &:hover {
    border: 1px solid ${colors.lightest_blue};
    background-color: ${colors.lightest_blue};
  }

  &.active {
    background-color: ${colors.light_blue};
    color: white;
    border: 0px;
  }
`;

export default CategoryRow;
